import { c as _c } from "react/compiler-runtime";
import CommonAnimationWrapper from "../animation/CommonAnimationWrapper";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import CommonAnimationOpacity from "../animation/CommonAnimationOpacity";
import SelectGroupModal from "./SelectGroupModal";
export default function SelectGroupModalWrapper(t0) {
  const $ = _c(6);
  const {
    isOpen,
    onClose,
    onGroupSelect
  } = t0;
  let t1;
  if ($[0] !== isOpen || $[1] !== onClose || $[2] !== onGroupSelect) {
    t1 = isOpen && <CommonAnimationOpacity elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><SelectGroupModal onClose={onClose} onGroupSelect={onGroupSelect} /></CommonAnimationOpacity>;
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = onGroupSelect;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <CommonAnimationWrapper mode="sync" initial={true}>{t1}</CommonAnimationWrapper>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(e) {
  return e.stopPropagation();
}